import { useMemo } from 'react';

import { useHashState } from 'utils/routes';

import { InventoryDashboardHashState } from 'types/hash-state';

export interface InventoryReportFilters {
  itemIds?: string[];
  locationIds?: string[];
  companyIds?: string[];
  stockable?: boolean;
  purchaseClasses?: string[];
  supplierIds?: string[];
  itemGroupIds?: string[];
  buyerIds?: string[];
  ruleIds?: string[];
}

/**
 * Builds the `filters` payload shared by the inventory report endpoints
 * (aging / average-age / metrics / transfers) from the dashboard hash-state filters.
 */
export function useInventoryReportFilters(): InventoryReportFilters {
  const [hashState] = useHashState<InventoryDashboardHashState>();
  const { filters } = hashState;

  return useMemo(
    () => ({
      itemIds: filters?.itemIds,
      locationIds: filters?.locationIds,
      companyIds: filters?.companyIds,
      stockable: filters?.stockable?.length === 1 ? filters.stockable[0] === 'true' : undefined,
      purchaseClasses: filters?.purchaseClasses,
      supplierIds: filters?.supplierIds,
      itemGroupIds: filters?.itemGroupIds,
      buyerIds: filters?.buyerIds,
      ruleIds: filters?.ruleIds,
    }),
    [filters],
  );
}
